import {takeLatest, put, call} from 'redux-saga/effects';
import apiCall from '../../api';
import {DELETE_BANNER_ERROR, DELETE_BANNER_START, DELETE_BANNER_SUCCESS} from "../../types";

export function* deleteBanner({payload}) {
    try {
        const url = `/banners/${payload.id}/`;
        const method = 'DELETE';
        const headers = {Authorization: 'Bearer ' + payload.token, 'Content-Type':'application/json'};
        const results = yield call(apiCall, url, method, payload.formData, headers);
        yield put({type: DELETE_BANNER_SUCCESS, results: results.data});
    } catch (error) {
        yield put({type: DELETE_BANNER_ERROR, error});
    }
}

export default function* delete_banner() {
    yield takeLatest(DELETE_BANNER_START, deleteBanner);
}